import { Component, useEffect } from "react";
import withRouter from "../../utils/withRouter";
import { ProductManager } from "./products";
import { BiChevronLeft } from "react-icons/bi";

function CategoryProducts(){
    // const { get: getCategory, loading } = useAPI();

    // const [categories, setCategories] = useState([]);
    // const fetchCategory = async () => {
    //     try {
    //         const response = await getCategory("api/v1/admin/category", [], false);
    //         if(response["status"] == "success"){
    //             const data = response["data"]["categories"];
    //             setCategories(data);

    //         }
    //     } catch {

    //     } finally {

    //     }
    // }
    // useEffect(()=>{

    // }, [])
    return <div className="category-wrapper w-full p-5">
        <div className="flex flex-col gap-5 mb-16">
            <div className="flex items-center gap-3">
                <BiChevronLeft className="text-[#070E05] text-[25px] cursor-pointer" onClick={e=>{
                        const { navigate } = this.props;
                        navigate(`/products/`);
                }} />
                <div className="font-Neurial font-bold text-[20px] text-[#070E05]">{}</div>
            </div>
            <ProductManager />
        </div>
    </div>
}

export default CategoryProducts;